(function(){
"use strict";
// Solo lee estado real de Globo y refuerza la foto de acabado correspondiente.
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
const $=(q,r=document)=>r.querySelector(q);
const $$=(q,r=document)=>Array.from(r.querySelectorAll(q));
const normalize=x=>String(x||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\s+/g," ").trim().toUpperCase();
const keyOf=x=>{
 const t=normalize(x);
 if(!t||t.length>260)return null;
 if(t.includes("HIBRIDO")||t.includes("HYBRID"))return "hybrid";
 if(t.includes("GLOW")||t.includes("BRILLA EN LA OSCURIDAD"))return "glow";
 if(t.includes("HOLOGRAFICO")||t.includes("HOLOGRAPHIC"))return "holo";
 if(t.includes("TRANSPARENTE")||t.includes("TRANSPARENT"))return "clear";
 if(t.includes("FOTOGRAFICO")||t==="HD"||t.startsWith("ACABADO HD"))return "hd";
 return null;
};
const selectedMarkers='[aria-checked="true"],[aria-selected="true"],[data-selected="true"],.gpo-selected,.is-selected,.gpo-swatch.selected,.gpo-swatch.active,.gpo-swatch.checked';
function finishGroup(){
 const fromGuide=$(".kira-v4-finish-guide.kira-v5-single");
 const before=fromGuide?.previousElementSibling;
 if(before&&before.querySelector("img")&&!before.querySelector(".kira-tipo-funda"))return before;
 const native=$(".product-information .kira-v7-finish-native,.product-information .kira-acabados");
 return native?.querySelector("img")?native:null;
}
function actualSelectedKey(group){
 for(const input of $$("input[type=radio]:checked,input[type=checkbox]:checked,option:checked",group)){
  const direct=keyOf(input.value)||keyOf(input.getAttribute("data-value"));
  if(direct)return direct;
  const label=input.id?$$("label",group).find(x=>x.htmlFor===input.id):null;
  const parent=label||input.closest("label,.gpo-swatch,.gpo-swatch__item,[role=radio]")||input.parentElement;
  const named=keyOf(parent?.getAttribute?.("data-value"))||keyOf(parent?.getAttribute?.("aria-label"))||keyOf(parent?.textContent);
  if(named)return named;
 }
 for(const mark of $$(selectedMarkers,group)){
  const parent=mark.closest("label,.gpo-swatch,.gpo-swatch__item,[role=radio]")||mark;
  const named=keyOf(parent.getAttribute("data-value"))||keyOf(parent.getAttribute("aria-label"))||keyOf(parent.textContent);
  if(named)return named;
 }
 // La guía de efectos ya sigue el mismo Globo; alternativa sólo visual, no compra.
 const guide=$(".kira-v4-finish-guide.kira-v5-single");
 const chosen=$(".kp-finish-card.kira-v5-picked .kp-finish-name",guide||document);
 return chosen?keyOf(chosen.textContent):null;
}
function optionCardFor(img,group){
 let node=img.parentElement;
 for(let depth=0;node&&node!==group&&depth<9;depth++,node=node.parentElement){
  if(node.querySelectorAll("img").length!==1)break;
  const direct=keyOf(node.getAttribute("data-value"))||keyOf(node.getAttribute("aria-label"));
  const text=normalize(node.textContent);
  const k=direct||text.length<260&&keyOf(text);
  if(k && node!==group)return {img,root:node,key:k};
 }
 return null;
}
let previously=null;
function apply(){
 const group=finishGroup();if(!group)return;
 const cards=$$("img",group).filter(img=>img.getBoundingClientRect().width>=45&&img.getBoundingClientRect().height>=50)
  .map(img=>optionCardFor(img,group)).filter(Boolean);
 const key=actualSelectedKey(group);
 const matches=key?cards.filter(c=>c.key===key):[];
 const chosen=matches.length===1?matches[0]:null;
 const found=group.querySelectorAll(".kira-v10-finish-picked");
 if(found.length===1&&chosen?.img===found[0])return;
 $$(".kira-v10-finish-picked,.kira-v10-finish-card-picked,.kira-v10-flash",group).forEach(node=>
  node.classList.remove("kira-v10-finish-picked","kira-v10-finish-card-picked","kira-v10-flash"));
 if(chosen){
  chosen.img.classList.add("kira-v10-finish-picked");
  // No aplicar sombras a un contenedor con varias alternativas.
  if(chosen.root.querySelectorAll("img").length===1&&chosen.root!==group)chosen.root.classList.add("kira-v10-finish-card-picked");
  if(previously && previously!==key)chosen.img.classList.add("kira-v10-flash");
  previously=key;
 }
}
let pending=false;
function schedule(){
 if(pending)return;pending=true;
 requestAnimationFrame(()=>{pending=false;apply();});
}
function start(){
 schedule();
 document.addEventListener("change",()=>{schedule();setTimeout(schedule,100);},true);
 document.addEventListener("click",()=>{setTimeout(schedule,60);setTimeout(schedule,180);},true);
 document.addEventListener("gpoRenderCompleted",schedule);
 const root=$(".product-information");
 if(root)new MutationObserver(schedule).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:["checked","aria-checked","aria-selected","data-selected"]});
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
else start();
})();